// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/b387f9df/" + chunkId + "." + __webpack_require__.h() + ".vb387f9df.js";
};